import React from 'react'

import { formatDate } from '../../options'
import { Typography } from '@material-ui/core'

// Zakres dat kursu, np. 01.09.2026–15.12.2026 (półpauza bez spacji). Potrzebne obie daty: wcześniej warunek
// `fromDate && fromDate` przy braku toDate pokazywał dzisiejszą datę jako koniec kursu.
const dateRange = (course) => {
  if (!(course.fromDate && course.toDate)) return null

  const from = formatDate(course.fromDate)
  const to = formatDate(course.toDate)

  return from && to ? `${from}–${to}` : null
}

export const displayText = course => (
  `${course.kind && course.kind.name} [${course.prefix}] ${course.name} ${course.city && course.city.name}  ` +
  (dateRange(course) ? ` ${dateRange(course)}` : '')
)

const displayHTML = course => {
  const dates = dateRange(course)

  return (
    <Typography paragraph={true} variant={'body1'} style={{ fontWeight: 700 }}>
      {course.kind && course.kind.name}
      <br />
      [{course.prefix}] {course.name}
      <br />
      {course.city && course.city.name}
      {
        dates ?
          <Typography variant={'body1'} component={'span'} style={{ fontWeight: 700 }}>
            {' '} {dates}
          </Typography>
          :
          null
      }
    </Typography>
  )
}

// Brak kursu (ankieta bez pola `course`, błąd pobrania kursu): nagłówek ankiety bez wiersza z kursem.
const CourseDisplayName = (props) => (
  !props.course ?
    null
    :
    props.displayAsText ?
      displayText(props.course)
      :
      displayHTML(props.course)
)

export default CourseDisplayName